import { useContext } from "react";
import AlertContext from "../../context/AlertContext";
import { StudentTestPageContext } from "../../context/StudentTestPageContext";

export default function InterviewBodyHooks() {
  const Alert = useContext(AlertContext);
  const StudentTestPageCxt = useContext(StudentTestPageContext);

  const handleReport = () => {
    Alert.updateComingObj((prev) => ({
      ...prev,
      answer: prev.answer.map((data) =>
        data.qnid === StudentTestPageCxt.currentQnData.id
          ? { ...data, report: true }
          : data
      ),
    }));
    StudentTestPageCxt.setCurrentQnData((prev) => ({
      ...prev,
      report: true,
    }));
  };

  return { handleReport };
}
